import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const hotelApiEndPoint = `${process.env.NEXT_PUBLIC_APP_API_URL}/api/admin/hotel`;

export const getAdminHotelsListThunk = createAsyncThunk(
    "admin-hotels-list",
    async ({ token, params }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${hotelApiEndPoint}/list`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to fetch hotel bookings" }
            )
        }
    }
)

export const getAdminHotelDetailsThunk = createAsyncThunk(
    "admin-hotel-details",
    async ({ token, hotelId }, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${hotelApiEndPoint}/details/${hotelId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            return response?.data
        } catch (error) {
            return rejectWithValue(
                error.response?.data || { message: "Failed to fetch hotel booking" }
            )
        }
    }
)
